import { dropRightWhile, dropWhile, isNil, orderBy } from 'lodash-es';
import { type GqlSnrCase, type GqlSnrShareCapitalChange } from '../../../../graphql/base-types.graphql';

type SnrCase = Pick<GqlSnrCase, 'filingYear' | 'filingNumber' | 'subjects' | 'arrivalDate'>;
type ShareCapitalChange = Pick<GqlSnrShareCapitalChange, 'filingYear' | 'filingNumber'>;

export function snrCasesBetweenSccs(
  snrCases: SnrCase[],
  previousShareCapitalChange: ShareCapitalChange | null | undefined,
  shareCapitalChange: ShareCapitalChange | null | undefined,
): SnrCase[] {
  let relevantSnrCases = orderBy(snrCases, s => s.arrivalDate, 'desc');
  if (!isNil(shareCapitalChange)) {
    relevantSnrCases = dropWhile(snrCases, e => {
      return (
        parseInt(e.filingYear, 10) !== parseInt(shareCapitalChange.filingYear, 10) &&
        parseInt(e.filingNumber, 10) !== parseInt(shareCapitalChange.filingNumber, 10)
      );
    });
  }
  if (!isNil(previousShareCapitalChange)) {
    relevantSnrCases = dropRightWhile(relevantSnrCases, e => {
      return (
        parseInt(e.filingYear, 10) !== parseInt(previousShareCapitalChange.filingYear, 10) &&
        parseInt(e.filingNumber, 10) !== parseInt(previousShareCapitalChange.filingNumber, 10)
      );
    });
  }
  relevantSnrCases = relevantSnrCases.filter(e => {
    return e.subjects.map(s => s.value).includes('Ändring av bolagsordning');
  });
  return orderBy(relevantSnrCases, s => s.arrivalDate, 'asc');
}
